
// Recursively remove properties from an object
const removeProperty = (obj, propsToRemove) => {
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }

    if (Array.isArray(obj)) {
        return obj.map(item => { return removeProperty(item, propsToRemove) });
    }

    const newObj = {};
    for (const key in obj) {
        if (!propsToRemove.includes(key)) {
            newObj[key] = removeProperty(obj[key], propsToRemove);
        }
    }

    return newObj;
};

module.exports = class StrapiReducer {
    static reduceLocations = (data) => {
        // Remove cities that do not have stops
        data.data.forEach((country) => {
            if (country.attributes.states) {
                country.attributes.states.data.forEach((state) => {
                    if (state.attributes.cities?.data) {
                        state.attributes.cities.data = state.attributes.cities.data.filter((city) => {
                            const stops = city.attributes.stops?.data.filter((stop) => {
                                const partner_location_keys = stop.attributes.partner_location_keys?.data.filter((partner_location_key) => partner_location_key.attributes.partner_location_active);
                                return stop.attributes.stop_enabled && partner_location_keys && partner_location_keys.length > 0;
                            }
                            );
                            const nearby_stops = city.attributes.nearby_stops?.data.filter((stop) => {
                                const partner_location_keys = stop.attributes.partner_location_keys?.data.filter((partner_location_key) => partner_location_key.attributes.partner_location_active);
                                return stop.attributes.stop_enabled && partner_location_keys && partner_location_keys.length > 0;
                            }
                            );
                            /*
                            if ((!stops  || stops.length == 0) &&
                            (!nearby_stops || nearby_stops.length == 0)) {
                                console.log("Removing city: " + city.attributes.city_name);
                            }
                            */
                            return (stops && stops.length > 0) ||
                                (nearby_stops && nearby_stops.length > 0)
                        }
                        );
                    }
                });
            }
        });
        // Now that we removed cities without stops, we don't need the stops info.
        // The 'id' property is also not needed.
        const newData = removeProperty(data, ['id', 'stops', 'nearby_stops']);
        return newData;
    };
};